import type { TutorPaymentPolicySelectReturn } from './interfaces'

import { TutorCategoryType } from '@entities/tutor'

import { usePaymentPoliciesStore } from './store'
import { useTutorPaymentPolicySelect } from './tutor-payment-policy-select.hook'

export const useSelectPaidEla = (): TutorPaymentPolicySelectReturn => {
  const paymentPoliciesStore = usePaymentPoliciesStore()

  return useTutorPaymentPolicySelect({
    category: TutorCategoryType.PaidEla,
    label: 'Paid ELA',
    getValue: () => paymentPoliciesStore.selectedPaidEla as number | null,
    setValue: (value) => paymentPoliciesStore.setSelectedPaidEla(value),
  })
}
